import * as APIModels from "../../../models";
import { useState, useEffect } from "react";
import DocumentView from "./DocumentView";
import PDFViewer from "./PDFViewer";
import NewCase from "./forms/NewCase";
import ExistingCase from "./forms/ExistingCase";
import DFS from "./forms/DFS";
import Order from "./forms/Order";
import { useCallback } from "react";
import { SubmissionService } from "../../../services/SubmissionService";
import { MessageRulesService } from "../../../services/ClientService";
import HoldModal from "./modals/HoldModal";
import FailModal from "./modals/FailModal";
//import { PDFViewer } from "pdfjs-dist/web/pdf_viewer";

export default function SubmissionForm({
    submission,
    setNextSubmission,
    filter,
}: {
    submission: APIModels.Submission;
    setNextSubmission: (next: APIModels.Submission) => void;
    filter?: string;
}) {
    const [currentSubmission, setCurrentSubmission] = useState(submission);
    const [selectedDocument, setSelectedDocument] = useState(
        submission.documents
            ? submission.documents[0]
            : new APIModels.Document()
    );
    const [holdModalShow, setHoldModalShow] = useState(false);
    const [failModalShow, setFailModalShow] = useState(false);
    const [showPdfViewer, setShowPdfViewer] = useState(false);

    useEffect(() => {
        MessageRulesService.rule({
            attorneyId: submission.attorneyID!,
            county: submission.caseData?.county,
            filename: submission.filename,
            claimAmount: parseInt(submission.caseData?.claimAmount ?? "0"),
        }).then(
            (resp) => {
                if (resp.successful && resp.data != "") {
                    alert(resp.data);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [submission]);

    useEffect(() => {
        setCurrentSubmission(submission);

        setSelectedDocument(
            submission.documents
                ? submission.documents[0]
                : new APIModels.Document()
        );
    }, [submission]);

    useEffect(() => {
        if (
            submission &&
            submission.filename &&
            submission.filename.indexOf("-d-") > -1
        ) {
            setShowPdfViewer(true);

            const summons = submission.documents?.find((d) =>
                d.filename?.includes("DFS_Summons")
            );

            if (summons) {
                setSelectedDocument(summons);
            }
        }
    }, [currentSubmission]);

    const onSelectDocument = (doc: APIModels.Document, index: number) => {
        setSelectedDocument(doc);
    };

    const cancel = (submissionId: string) => {
        SubmissionService.cancel({ submissionId, body: {} }).then(
            (resp) => {
                window.location.href = "/queue/" + filter;
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const hold = (submissionId: string, reason: string, details: string) => {
        SubmissionService.hold({
            submissionId,
            body: { defaultMessage: parseInt(reason), message: details },
        }).then(
            (resp) => {
                window.location.href = "/queue/" + filter;
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const fail = (submissionId: string, reason: string, details: string) => {
        SubmissionService.fail({
            submissionId,
            body: { defaultMessage: parseInt(reason), message: details },
        }).then(
            (resp) => {
                window.location.href = "/queue/" + filter;
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const renderForm = useCallback(
        (filename: string) => {
            if (filename.indexOf("-a-0-") > 0) {
                return (
                    <NewCase
                        submission={currentSubmission}
                        onSelectDocument={onSelectDocument}
                        filter={filter}
                        currentDocument={selectedDocument}
                    />
                );
            } else if (filename.indexOf("-d-0-") > 0) {
                return <DFS submission={currentSubmission} filter={filter} />;
            } else if (filename.indexOf("-o-0-") > 0) {
                return (
                    <Order
                        submission={currentSubmission}
                        onSelectDocument={onSelectDocument}
                        setNextSubmission={setNextSubmission}
                        filter={filter}
                    />
                );
            } else {
                return (
                    <ExistingCase
                        submission={currentSubmission}
                        onSelectDocument={onSelectDocument}
                        setNextSubmission={setNextSubmission}
                        filter={filter}
                    />
                );
            }
        },
        [currentSubmission, selectedDocument]
    );

    return (
        <div className="row">
            {currentSubmission.id && (
                <>
                    <HoldModal
                        show={holdModalShow}
                        onHold={(reason: string, details: string) => {
                            setHoldModalShow(false);
                            hold(submission.id!, reason, details);
                        }}
                        onClose={() => setHoldModalShow(false)}
                    />
                    <FailModal
                        show={failModalShow}
                        onFail={(reason: string, details: string) => {
                            setFailModalShow(false);
                            fail(submission.id!, reason, details);
                        }}
                        onCancel={() => setFailModalShow(false)}
                    />
                    <div className="col-lg-6">
                        <div className="card">
                            <div className="card-body py-2 px-3 border-bottom border-light">
                                <div className="d-flex py-1">
                                    <div className="flex-1">
                                        <h5 className="mt-0 mb-0 font-15">
                                            <a
                                                href="contacts-profile.html"
                                                className="text-reset"
                                            >
                                                {`${submission.attorney?.lastName}, ${submission.attorney?.firstName}`}
                                            </a>
                                        </h5>
                                    </div>
                                    <div id="tooltip-container">
                                        <a
                                            href="javascript: void(0);"
                                            className="text-reset font-19 py-1 px-2 d-inline-block"
                                            title="Place file in hold queue"
                                            onClick={() =>
                                                setHoldModalShow(true)
                                            }
                                        >
                                            <i
                                                className="fe-pause"
                                                data-bs-container="#tooltip-container"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Place file in hold queue"
                                                data-bs-original-title="Voice Call"
                                                aria-label="Voice Call"
                                            ></i>
                                        </a>
                                        <a
                                            href="javascript: void(0);"
                                            className="text-reset font-19 py-1 px-2 d-inline-block"
                                            title="Stop working on current file."
                                            onClick={() =>
                                                cancel(submission.id!)
                                            }
                                        >
                                            <i
                                                className="fe-stop-circle"
                                                data-bs-container="#tooltip-container"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Stop working on current file."
                                                data-bs-original-title="Video Call"
                                                aria-label="Video Call"
                                            ></i>
                                        </a>
                                        <a
                                            href="javascript: void(0);"
                                            className="text-reset font-19 py-1 px-2 d-inline-block"
                                            title="Fail file back to submitting attorney."
                                            onClick={() =>
                                                setFailModalShow(true)
                                            }
                                        >
                                            <i
                                                className="fe-trash-2"
                                                data-bs-container="#tooltip-container"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Fail file back to submitting attorney."
                                                data-bs-original-title="Add Users"
                                                aria-label="Add Users"
                                            ></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        {renderForm(
                                            currentSubmission.filename!
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-sm-4">
                                <button
                                    className="btn btn-primary me-5"
                                    onClick={() => {
                                        if (currentSubmission.documents) {
                                            let currentIndex =
                                                currentSubmission.documents.indexOf(
                                                    selectedDocument
                                                );
                                            if (currentIndex - 1 >= 0) {
                                                currentIndex = currentIndex - 1;
                                            } else {
                                                currentIndex =
                                                    currentSubmission.documents
                                                        .length - 1;
                                            }
                                            setSelectedDocument(
                                                currentSubmission.documents[
                                                    currentIndex
                                                ]
                                            );
                                        }
                                    }}
                                >
                                    Previous
                                </button>
                            </div>
                            <div className="col-sm-4 text-center">
                                <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                        setShowPdfViewer(!showPdfViewer)
                                    }
                                >
                                    PDF Viewer
                                </button>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    className="btn btn-primary"
                                    style={{ float: "right" }}
                                    onClick={() => {
                                        if (currentSubmission.documents) {
                                            let currentIndex =
                                                currentSubmission.documents.indexOf(
                                                    selectedDocument
                                                );
                                            if (
                                                currentIndex + 1 <
                                                currentSubmission.documents
                                                    .length
                                            ) {
                                                currentIndex = currentIndex + 1;
                                            } else {
                                                currentIndex = 0;
                                            }
                                            setSelectedDocument(
                                                currentSubmission.documents[
                                                    currentIndex
                                                ]
                                            );
                                        }
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                        {selectedDocument &&
                            selectedDocument.id &&
                            (showPdfViewer ? (
                                <PDFViewer
                                    submissionId={currentSubmission.id!}
                                    documentId={selectedDocument.id!}
                                    filename={selectedDocument.filename!}
                                />
                            ) : (
                                <DocumentView
                                    submissionId={currentSubmission.id!}
                                    documentId={selectedDocument.id!}
                                    filename={selectedDocument.filename!}
                                />
                            ))}
                    </div>
                </>
            )}
        </div>
    );
}
